// src/constants/api.js
//export const API_URL = 'http://localhost:3001';
//export const API_URL = "https://demobackend.kaafi.net";
//export const API_URL = 'https://tanaad_api.kaafi.net';
//export const API_URL = 'https://muraalapi.kaafi.net';

import axios from 'axios';
import { getToken } from '../utils/TokenUtils';

//console.log('api url:', process.env.REACT_APP_API_URL);
export const API_URL = process.env.REACT_APP_API_URL; // Fallback to localhost if env variable is not set
export const API_URL2 = process.env.REACT_APP_API_URL2; // Fallback to localhost if env variable is not set

export const REACT_APP_LAYOUT = process.env.REACT_APP_LAYOUT || 'V1'; // Fallback to localhost if env variable is not set

export const KTC_API_URL_SOCKET = 'https://newktcapi.kaafi.net'; // Fallback to localhost if env variable is not set
export const KTC_API_ENABLE_SOCKET =
  process.env.REACT_APP_ENABLE_SOCKET || 'true'; // Fallback to localhost if env variable is not set
// console.log('tf:', process.env.REACT_APP_ENABLE_SOCKET);
export const MOBILE_WEB_URL =
  process.env.REACT_APP_WEB_URL || process.env.REACT_APP_MOBILE_URL; // Fallback to localhost if env variable is not set
// console.log('All env vars:', process.env);
export const TIMEOUT = 5000; // milliseconds

// API Endpoints
export const ENDPOINTS = {
  SYS: 'api/sys',
  SQL: 'api/sql',
  USER: 'api/users',
};

export const getData = async (url) => {
  const token = getToken();
  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    const data = response.data || [];
    // console.log('url:', url, 'response:', data);
    return data;
  } catch (error) {
    console.error('Error fetching', url, ':', error);
  }
};

export const postData = async (url, body) => {
  const token = getToken();
  try {
    const response = await axios.post(url, body, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    const data = response.data || [];
    // console.log('url:', url, 'request:', body, 'response:', data);
    return data;
  } catch (error) {
    console.error('Error fetching ', url, ':', error);
  }
};
